'use client';

import { AngledArrowDownIcon, AngledArrowUpIcon } from '@/src/features/ui/icons/icons';
import { PosProductCommissionsModel } from '@/src/interfaces/data-contracts';
import { useEffect, useState } from 'react';

import { formatInterestRate } from '@/src/utils/helpers/replace-dot-with-comma';

type Props = {
  commissions: PosProductCommissionsModel[] | null;
};

let BTN_ICON = <AngledArrowDownIcon />;

export const WidgetTable: React.FC<Props> = ({ commissions }) => {
  const [showMoreBtn, setShowMoreBtn] = useState(false);
  const [showMoreBtnText, setShowMoreBtnText] = useState('Daha Fazla Gör');
  const [commissionsVisibility, setCommissionsVisibility] = useState(false);
  const [showHideContent, setShowHideContent] = useState(6);

  const commissionsData = commissions;
  const commissionsDataLength = commissionsData?.length;

  useEffect(() => {
    if (commissionsData && commissionsData?.length > 6) {
      setShowMoreBtn(true);
      setCommissionsVisibility(true);
    } else {
      setShowMoreBtn(false);
      setCommissionsVisibility(false);
    }
  }, [commissionsData]);

  const commissionsVisibleHandler = () => {
    if (showHideContent === 6) {
      setShowHideContent(commissionsDataLength ?? 0);
      setShowMoreBtnText('Daha Az Gör');
      BTN_ICON = <AngledArrowUpIcon />;
    } else {
      setShowHideContent(6);
      setShowMoreBtnText('Daha Fazla Gör');
      BTN_ICON = <AngledArrowDownIcon />;
    }
  };

  return (
    <div className="flex flex-col items-center gap-5 md:gap-6" data-testid="posTable">
      <div className="container">
        <table className="block w-full table-auto md:table">
          <thead>
            <tr>
              <th className="w-full whitespace-nowrap bg-black600 px-6 py-4 text-left text-sm font-semibold text-white">
                Taksit
              </th>
              <th className="w-full whitespace-nowrap bg-black600 px-6 py-4 text-right text-sm font-semibold text-white">
                Faiz Oranı
              </th>
            </tr>
          </thead>
          <tbody>
            {commissionsVisibility
              ? commissions?.slice(0, showHideContent).map((item, index) => (
                  <tr className="even:bg-black100" key={item.id}>
                    <td className="whitespace-nowrap px-6 py-4 text-left text-sm font-bold text-black800">
                      {item.installment === 1 ? 'Tek Çekim' : item.installment + '. Taksit'}
                    </td>
                    <td className="whitespace-nowrap px-6 py-4 text-right text-sm font-bold text-black800">
                      {'%' + formatInterestRate(item.rate)}
                    </td>
                  </tr>
                ))
              : commissions?.map((item, index) => (
                  <tr className="even:bg-black100" key={item.id}>
                    <td className="whitespace-nowrap px-6 py-4 text-left text-sm font-bold text-black800">
                      {item.installment === 1 ? 'Tek Çekim' : item.installment + '. Taksit'}
                    </td>
                    <td className="whitespace-nowrap px-6 py-4 text-right text-sm font-bold text-black800">
                      {'%' + formatInterestRate(item.rate)}
                    </td>
                  </tr>
                ))}
          </tbody>
        </table>
      </div>
      {showMoreBtn && (
        <button
          onClick={commissionsVisibleHandler}
          className="flex items-center gap-2 text-base font-bold text-purple500"
          data-testid="showMoreButton"
        >
          {showMoreBtnText} {BTN_ICON}
        </button>
      )}
    </div>
  );
};
